var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShiftScrollTip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    viewBox: "0 0 533 177",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0023 0 0 .83658 -99.956 -117.16)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99.729,
    y: 140.04,
    width: 530.86,
    height: 211.01,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.73986 0 0 .88639 533.66 255.7)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-100 -100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m112.5 14.063h-25c-26.561 0.029-48.408 21.876-48.437 48.437v75c0.029 26.561 21.876 48.408 48.437 48.438h25c26.561-0.03 48.408-21.877 48.438-48.438v-75c-0.03-26.561-21.877-48.408-48.438-48.437zm39.063 48.437v20.313h-46.875v-59.375h7.812c21.419 0.025 39.037 17.643 39.063 39.062zm-64.063-39.062h7.813v59.375h-46.875v-20.313c0.025-21.419 17.643-39.037 39.062-39.063zm25 153.12h-25c-21.419-0.026-39.037-17.644-39.063-39.063l1e-3 -45.312h103.12v45.312c-0.026 21.419-17.644 39.037-39.063 39.063z",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.99774 0 0 1.1954 2.1554 -48.378)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m372.13 225.54v53.872c0 14.867-12.07 26.936-26.936 26.936h-199.4c-14.867 0-26.936-12.069-26.936-26.936v-53.872c0-14.867 12.069-26.936 26.936-26.936h199.4c14.866 0 26.936 12.069 26.936 26.936z",
    fillOpacity: 0,
    stroke: "#000",
    strokeWidth: "6px"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.99774 0 0 1.1954 -27.24 -31.128)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "239.576px",
    y: "261.283px",
    fontFamily: "'ArialMT', 'Arial', sans-serif",
    fontSize: "64px"
  }, "shift")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.4724 0 0 1.7641 54.975 -181.29)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "239.576px",
    y: "261.283px",
    fontFamily: "'Beirut'",
    fontSize: "64px",
    fontWeight: 700
  }, "+")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.41486 0 0 .49703 170.08 249.56)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-100 -100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m131.25 175h-62.5c-3.45 0-6.25-2.8-6.25-6.25v-68.75h-25c-2.525 0-4.812-1.525-5.775-3.862-0.963-2.338-0.438-5.025 1.35-6.813l62.5-62.5c2.438-2.437 6.4-2.437 8.837 0l62.501 62.5c1.787 1.788 2.324 4.475 1.35 6.813-0.975 2.337-3.25 3.862-5.775 3.862h-25v68.75c0 3.45-2.8 6.25-6.25 6.25h0.012zm-56.25-12.5h50v-68.75c0-3.45 2.8-6.25 6.25-6.25h16.163l-47.413-47.412-47.413 47.412h16.163c3.45 0 6.25 2.8 6.25 6.25v68.75z",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3496 0 0 1.6169 -304.64 -89.402)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "653.325px",
    y: "204.697px",
    fontFamily: "'AppleSDGothicNeo-Bold', 'Apple SD Gothic Neo'",
    fontSize: "64px",
    fontWeight: 700
  }, "\u2195")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShiftScrollTip);
export default __webpack_public_path__ + "static/media/shift-scroll-tip.772f48784178814bf9f8d6a3e5551ccc.svg";
export { ForwardRef as ReactComponent };